import React, { Component } from 'react'
import img8 from '../../assets/images/img8.png'
import img7 from '../../assets/images/img7.png'
import img2 from '../../assets/images/2.jpg'
import '../../assets/css/Introduction.css'
import '../../assets/css/Residential.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import { Link } from 'react-router-dom';

class Introduction extends Component {
    render() {
        return (
            <>
                <div className="resHeader" style={{ paddingTop: '0', paddingBottom: '0' }}>
                    <h3 className="fit">Signature Move</h3>
                    <h3 className="fit">Investment Group</h3>
                    <p>Signature Move Investment Group is a property development firm specializing in luxury residential real estate. Founded in 2018, the vision of the company has always been to provide the highest quality homes in the market. All of our homes feature innovative architectural designs along with high end interior finishes, making them one-of-a-kind homes that any family will cherish for a lifetime.</p>
                </div>
                <div>
                    <div className="welcomeBG">
                        <img src={img8} className="respImg" alt="png" />
                        <div className='respHeader' style={{ textAlign: 'center' }}>
                            <Fade bottom duration={500}>
                                <h3 >FIND YOUR SIGNATURE MOVE</h3>
                            </Fade>
                            <Fade bottom duration={500}>
                                <p className='goneText'>For the individuals who look for an uncommon home and life, there is just Signature Move Investment Group. We offer extravagance that gives a remarkable degree of refinement, unwinding and style. A remarkable encounter to be delighted in the harmony and sociability of your confidential chalet, with all the solace of a lavish lifestyle!</p>
                            </Fade>
                        </div>
                    </div>
                </div>
                <div className="mainContIntro">
                    <div className="contImgIntro">
                        <div className="contIntro" style={{ paddingTop: '60px' }}>
                            <div className='topRow'>
                                <Zoom top>
                                    <h3 style={{ paddingBottom: "20px", paddingRight: '20px' }}><span>78 </span>COUNTRIES & TERRITORIES</h3>
                                </Zoom>
                                <Zoom top>
                                    <h3 style={{ paddingBottom: "20px", paddingLeft: '20px' }}><span>25,000 </span>SALES ASSOCIATES</h3>
                                </Zoom>
                            </div>
                            <div className='bottomRow'>
                                <Zoom top>
                                    <h3 style={{ paddingBottom: "20px" }}><span>$204 Billion </span>ANNUAL SALES (USD)</h3>
                                </Zoom>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default Introduction;